import apiClient from "api/client";

export async function fetchPayrollById(id = '68ad65e1b7a8284430aa8316') {
    try {
        let payrollBYId = await apiClient.get(`/payroll/${id}/json`)
        return payrollBYId.data.data
    } catch (err) {
        throw err
    }
}

export async function fetchBillingDetailsByPayrollId(id = '68ad65e1b7a8284430aa8316') {
    try {
        let billingDetailsById = await apiClient.get(`/payroll/billing/${id}/`)
        const payload = billingDetailsById.data.data
        return Array.isArray(payload) ? (payload[0] || null) : payload
    } catch (err) {
        throw err
    }
}

export async function updateBillingDetailsById(id, updates) {
    try {
        let updatedBillingDetails = await apiClient.put(`/payroll/billing/${id}/`, {
            updates: updates
        })
        return updatedBillingDetails.data.data
    } catch (err) {
        throw err
    }
}
